import { Wrapper } from '@american-autonomy/ag-ui';

import BatteryDetailDrawer from 'pages/MaintenancePage/components/BatteryDetailDrawer';
import DroneDetailDrawer from 'pages/MaintenancePage/components/DroneDetailDrawer';

import { TEST_ID } from './constants';
import type { FunctionComponent, OnEditRecord, OnVoidRecord, Props } from './types';

// Overlay cluster for the page's two slide-in drawers. Both drawers are
// position: fixed, so the wrapper is layout-inert.
const MaintenanceDrawers: FunctionComponent<Props> = ({
    className = '',
    data,
    phase,
    testId = TEST_ID
}) => {
    const drawerRecords = data.drawerDrone ? (data.serviceRecords[data.drawerDrone.id] ?? []) : [];

    // The drawer's service tab works per-drone; bind the drawer drone's id here so the
    // tab-level callbacks stay droneId-free.
    const handleOpenDrawerLogService = () => {
        if (!data.drawerDrone) {
            return;
        }

        data.handleOpenLogService(data.drawerDrone.id);
    };

    const handleVoidDrawerRecord: OnVoidRecord = ({ recordId }) => {
        if (!data.drawerDrone) {
            return;
        }

        data.voidService({ droneId: data.drawerDrone.id, recordId });
    };

    const handleEditDrawerRecord: OnEditRecord = ({ recordId }) => {
        if (!data.drawerDrone) {
            return;
        }

        data.handleOpenEditService({ droneId: data.drawerDrone.id, recordId });
    };

    return (
        <Wrapper className={className} testId={testId}>
            <DroneDetailDrawer
                activeTab={data.activeTab}
                drone={data.drawerDrone}
                droneNames={data.droneNames}
                isAdmin={data.isAdmin}
                isOpen={data.isDrawerOpen}
                onAdd={data.handleAddToCart}
                onClose={data.handleCloseDrawer}
                onEditRecord={handleEditDrawerRecord}
                onOpenLogService={handleOpenDrawerLogService}
                onSetAirworthy={data.setAirworthy}
                onSetLifecycle={data.setLifecycle}
                onTabChange={data.setActiveTab}
                onVoidRecord={handleVoidDrawerRecord}
                phase={phase}
                records={drawerRecords}
                serviceIntervals={data.serviceIntervals}
            />

            <BatteryDetailDrawer
                activeTab={data.activeBatteryTab}
                battery={data.drawerBattery}
                cycleInterval={data.batteryCycleInterval}
                droneNames={data.droneNames}
                isAdmin={data.isAdmin}
                isOpen={data.isBatteryDrawerOpen}
                onClose={data.handleCloseBatteryDrawer}
                onSetStatus={data.setBatteryStatus}
                onTabChange={data.handleBatteryTabChange}
                phase={phase}
            />
        </Wrapper>
    );
};

export default MaintenanceDrawers;
